import React from "react";

global.platformURI = 'https://calendar-api.deviare.co.za/'
global.cookieURI = process.env.REACT_APP_KEYCLOAK_COOKIE_ENDPOINT;
global.keycloak = "http://identity.deviare.co.za/cookie.php?identity=";
// global.keycloak = process.env.REACT_APP_KEYCLOAK_COOKIE_ENDPOINT;
global.eLearningURI = 'https://accounts.simplilearn.com/api/v1/get-course-catalogue';